// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__uOW95","label":"SuperRadio_label__LmBNR","options":"SuperRadio_options__myLcM"};